import { HardDriveDownload } from 'lucide-react';
import { PageHeader } from '@/components/common/page-header';
import { EmptyState, ErrorState, LoadingRows } from '@/components/common/states';
import { DownloadList } from '@/components/movie/download-list';
import { useDownloads } from '@/hooks/use-downloads';
import { formatBytes } from '@/lib/crawl-labels';

export function DownloadsPage() {
  const downloads = useDownloads();
  return (
    <div className="space-y-6">
      <PageHeader
        title="Downloads"
        description={
          downloads.data === undefined
            ? 'Offline copies kept on the zyx service’s disk.'
            : `Offline copies kept on the zyx service’s disk, newest first: ${formatBytes(downloads.data.totalBytes)} in all. Download from a movie’s page.`
        }
      />
      {downloads.isPending ? (
        <LoadingRows rows={4} />
      ) : downloads.isError ? (
        <ErrorState error={downloads.error} onRetry={() => void downloads.refetch()} />
      ) : downloads.data.downloads.length === 0 ? (
        <EmptyState
          title="Nothing downloaded"
          description="The Download button on a movie’s page keeps a copy that plays offline and saves as an MP4."
          icon={<HardDriveDownload className="size-5" />}
        />
      ) : (
        <DownloadList downloads={downloads.data.downloads} showMovie />
      )}
    </div>
  );
}
